/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
import React, { StatelessComponent } from 'react';
import './_styles.scss';
import {
    DETAILTRANSACTION,
    DETAILTRANSACTION_TITLE,
    DETAILTRANSACTION_COLUMN_TITLE_STEP,
    DETAILTRANSACTION_ROW,
    DETAILTRANSACTION_COLUMN,
    DETAILTRANSACTION_COLUMN_CONTENT_IMAGE,
    DETAILTRANSACTION_COLUMN_TITLE,
    DETAILTRANSACTION_COLUMN_BUY_RENT,
    DETAILTRANSACTION_COLUMN_EPISODE,
    DETAILTRANSACTION_TITLE_EPISODE,
    DETAILTRANSACTION_COLUMN_SUSCRIPTION,
    DETAILTRANSACTION_COLUMN_NOTES,
    DETAILTRANSACTION_SUBTITLE,
    DETAILTRANSACTION_SUBTITLE_TOTAL,
    DETAILTRANSACTION_SUBTITLE_PRICE,
    DETAILTRANSACTION_SUBTITLE_SLASH,
    DETAILTRANSACTION_SUBTITLE_DURATION,
    DETAILTRANSACTION_SUBTITLE_CARGO,
    DETAILTRANSACTION_SUBTITLE_INFORMATION,
    DETAILTRANSACTION_BUTTON_ACCEPT,
    DETAILTRANSACTION_BUTTON_CANCEL,
    DETAILTRANSACTION_COLUMN_DISCLAIMER,
    DETAILTRANSACTION_COLUMN_EXTRA_DISCLAIMER,
    DETAILTRANSACTION_CONTENT,
    DETAILTRANSACTION_COINTAINER_NOTES,
    DETAILTRANSACTION_CONTAINER_IMAGE
} from '../utils/classes';
import {
    Grid,
    Row,
    Column,
    Button,
    cls,
} from 'packages/components';
import {shouldMetadataInfoShowed} from 'src/utils/Utils';
import {ITransactionLabelInfo} from 'src/payments/Interface/interface';

export enum TransactionDetailType {
    BUY_MOVIE = 1,
    RENT_MOVIE = 2,
    BUY_EPISODE = 3,
    BUY_SEASON = 4,
    SUSCRIPTION = 5,
}


export interface ITransactionDetailProps {
    transactionDetailType: TransactionDetailType,
    handleAcceptSavedPayway: () => void,
    handleAddPayway: () => void,
    handleCancelPayway: () => void,
    textBackButton: string,
    imgBackButton: string,
    title: string,
    contentImage?: string,
    contentNotes: string,
    contentTitle?: string,
    contentOriginalTitle?: string,
    titleSerie?: string,
    providerImage: string,
    frequency: number,
    duration: string,
    extraDisclaimer?: string,
    information: string,
    lblTotal: string,
    selectedPaymentMethod: string,
    textAcceptSavedPayway: string,
    textAddPayway: string,
    textCancelButton: string,
    textStep: string,
    showSavedPaywayButton: boolean,
    showAddPaywayButton: boolean,
    className?: string,
    checkoutPrice: ITransactionLabelInfo,
    checkoutTax: ITransactionLabelInfo,
    checkoutBonus: ITransactionLabelInfo
}

export const TransactionDetail: StatelessComponent<ITransactionDetailProps> =
    ({ transactionDetailType,
        handleAcceptSavedPayway, handleAddPayway, handleCancelPayway,
        title,
        contentImage, contentNotes,
        contentTitle,
        contentOriginalTitle,
        titleSerie,
        providerImage,
        frequency,
        duration,
        information,
        lblTotal,
        selectedPaymentMethod,
        textAcceptSavedPayway,
        textAddPayway,
        textCancelButton,
        showSavedPaywayButton,
        showAddPaywayButton,
        textStep,
        extraDisclaimer,
        className,
        checkoutPrice,
        checkoutTax,
        checkoutBonus,
    }): JSX.Element => {
        return (
            <Grid className={cls(className, DETAILTRANSACTION)}>
                <TransactionTitle title={title} textStep={textStep} />
                <Row className={cls(`${DETAILTRANSACTION_ROW}`)}>
                    <Column lg={2} />
                    <TransactionDetailImage contentImage={contentImage} />
                    <Column lg={4} className={DETAILTRANSACTION_CONTENT}>
                        <TransactionDetailContent
                            transactionType={transactionDetailType}
                            contentTitle={contentTitle}
                            contentOriginalTitle={contentOriginalTitle}
                            titleSerie={titleSerie}
                            providerImage={providerImage}
                            frequency={frequency}
                            checkoutPrice={checkoutPrice}
                            checkoutTax={checkoutTax}
                            checkoutBonus={checkoutBonus}
                            duration={duration}
                            lblTotal={lblTotal}
                            information={information}
                        />
                        <TransactionDetailContentNotes
                            transactionType={transactionDetailType}
                            extraDisclaimer={extraDisclaimer}
                            contentNotes={contentNotes}
                        />
                    </Column>
                    <Column lg={2} />
                </Row>
                <TransactionDetailButtons
                    handleAcceptSavedPayway={handleAcceptSavedPayway}
                    handleAddPayway={handleAddPayway}
                    handleCancelPayway={handleCancelPayway}
                    textAcceptSavedPayway={textAcceptSavedPayway}
                    textAddPayway={textAddPayway}
                    selectedPaymentMethod={selectedPaymentMethod}
                    showSavedPaywayButton={showSavedPaywayButton}
                    showAddPaywayButton={showAddPaywayButton}
                    textCancelButton={textCancelButton}
                />
            </Grid>
        );

    };


interface ITransactionDetailTitleProps {
    title: string;
    textStep: string;
    className?: string;
}

export const TransactionTitle: React.StatelessComponent<ITransactionDetailTitleProps> =
    ({ title, textStep, className }): JSX.Element => {
        return (
            <div className={className}>
                <Row className={cls(`${DETAILTRANSACTION_ROW}`, 'thin')}>
                    <Column lg={12} className={cls(`${DETAILTRANSACTION_COLUMN_TITLE_STEP}`)}>
                        {textStep && <p >{textStep}</p>}
                    </Column>
                </Row>
                <Row className={cls(`${DETAILTRANSACTION_ROW}`)}>
                    <Column lg={12} className={cls(`${DETAILTRANSACTION_COLUMN_TITLE}`)}>
                        <h1 className={cls(`${DETAILTRANSACTION_TITLE}`)} >
                            {title}
                        </h1>
                    </Column>
                </Row>
            </div>
        );
    }


interface ITransactionDetailImageProps {
    contentImage?: string;
}

const TransactionDetailImage: React.StatelessComponent<ITransactionDetailImageProps> =
    ({ contentImage }): JSX.Element => {
        return (
            <Column lg={4} className={cls(`${DETAILTRANSACTION_COLUMN_CONTENT_IMAGE}`)} >
                <img className={DETAILTRANSACTION_CONTAINER_IMAGE} src={contentImage} alt="offer" />
            </Column>
        );
    }

interface ITransactionDetailButtonsProps {
    handleAcceptSavedPayway: () => void,
    handleAddPayway: () => void,
    handleCancelPayway: () => void,
    textAcceptSavedPayway: string,
    textAddPayway: string,
    textCancelButton: string,
    selectedPaymentMethod: string,
    showSavedPaywayButton: boolean,
    showAddPaywayButton: boolean,
}

const TransactionDetailButtons: React.StatelessComponent<ITransactionDetailButtonsProps> =
    ({ handleAcceptSavedPayway, handleAddPayway, handleCancelPayway,
        textAcceptSavedPayway, textAddPayway, selectedPaymentMethod, textCancelButton,
        showSavedPaywayButton, showAddPaywayButton
    }): JSX.Element => {
        return (
            <div>
                {showSavedPaywayButton &&
                    <Row className={cls(`${DETAILTRANSACTION_ROW}`, 'button')}>
                        <Column lg={3}></Column>
                        <Column lg={6} className={cls(`${DETAILTRANSACTION_COLUMN}`, 'button')}>
                            <Button
                                type="button"
                                variant="primary"
                                className={cls(
                                    `focusable`,
                                    `${DETAILTRANSACTION_BUTTON_ACCEPT}`,
                                    'button-container',
                                    'initial-focus'
                                )}
                                onClick={handleAcceptSavedPayway}
                                block
                            >
                                {textAcceptSavedPayway}
                            </Button>
                        </Column>
                        <Column lg={3}></Column>
                    </Row>
                }
                {showSavedPaywayButton &&
                    <Row >
                        <Column lg={3}></Column>
                        <Column lg={6} className={cls(`${DETAILTRANSACTION_COLUMN}`, 'center')}>
                            <span>
                                {`${selectedPaymentMethod}`}
                            </span>
                        </Column>
                        <Column lg={3}></Column>
                    </Row>
                }
                {showAddPaywayButton &&
                    <Row className={cls(`${DETAILTRANSACTION_ROW}`, 'button')}>
                        <Column lg={3}></Column>
                        <Column lg={6} className={cls(`${DETAILTRANSACTION_COLUMN}`, 'button')}>
                            <Button
                                type="button"
                                variant={showSavedPaywayButton ? 'dark' : 'primary'}
                                className={cls(
                                    `focusable`,
                                    `${DETAILTRANSACTION_BUTTON_ACCEPT}`,
                                    'button-container',
                                    'initial-focus'
                                )}
                                onClick={handleAddPayway}
                                block
                            >
                                {textAddPayway}
                            </Button>
                        </Column>
                        <Column lg={3}></Column>
                    </Row>
                }
                {!(showSavedPaywayButton && showAddPaywayButton) &&
                    <Row className={cls(`${DETAILTRANSACTION_ROW}`, 'button')}>
                        <Column lg={3}></Column>
                        <Column lg={6} className={cls(`${DETAILTRANSACTION_COLUMN}`, 'button')}>
                            <Button
                                type="button"
                                variant='dark'
                                className={cls(
                                    `focusable`,
                                    `${DETAILTRANSACTION_BUTTON_CANCEL}`,
                                    'button-container'
                                )}
                                onClick={handleCancelPayway}
                                block
                            >
                                {textCancelButton}
                            </Button>
                        </Column>
                        <Column lg={3}></Column>
                    </Row>
                }
            </div>
        )
    };


interface ITransactionDetailContentProps {
    transactionType: TransactionDetailType,
    contentTitle?: string,
    contentOriginalTitle?: string,
    titleSerie?: string,
    providerImage: string,
    frequency: number,
    duration: string,
    information: string,
    lblTotal: string,
    checkoutPrice: ITransactionLabelInfo,
    checkoutTax: ITransactionLabelInfo,
    checkoutBonus: ITransactionLabelInfo,

}

const TransactionDetailContent: React.StatelessComponent<ITransactionDetailContentProps> =
    ({ transactionType, contentTitle, providerImage, frequency, duration, information, lblTotal, contentOriginalTitle, titleSerie,
        checkoutPrice, checkoutTax, checkoutBonus
    }): JSX.Element => {
        
        const metadataInfoPrice: any = {};
        const metadataInfoTax: any = {};
        const metadataInfoBonus: any = {};
    
        if (shouldMetadataInfoShowed()){
            metadataInfoPrice['data-metadata-key'] = checkoutPrice.key;
            metadataInfoTax['data-metadata-key'] = checkoutTax.key;
            metadataInfoBonus['data-metadata-key'] = checkoutBonus.key;
        }
        switch (transactionType) {
            case TransactionDetailType.BUY_EPISODE:

                return (
                    <Column className={cls(`${DETAILTRANSACTION_COLUMN_EPISODE}`)}>
                        <span className={cls(`${DETAILTRANSACTION_TITLE_EPISODE}`)} >{titleSerie}</span>
                        <br className='min-space'/>
                        {contentOriginalTitle && (
                            <span className={cls(`${DETAILTRANSACTION_TITLE_EPISODE}`)} >{contentOriginalTitle}</span>
                        )}
                        <br />
                        <span className={cls(`${DETAILTRANSACTION_SUBTITLE}`)} >{contentTitle}</span><br />
                        <span className={cls(`${DETAILTRANSACTION_SUBTITLE_TOTAL}`)} >{lblTotal}</span>
                        <span {...metadataInfoPrice} className={cls(`${DETAILTRANSACTION_SUBTITLE_PRICE}`)} >{checkoutPrice.label}</span>
                        {checkoutPrice.label && <span {...metadataInfoTax} className={cls(`${DETAILTRANSACTION_SUBTITLE_DURATION}`)}>{checkoutTax.label}</span>}
                    </Column>
                );
                case TransactionDetailType.BUY_MOVIE:
                        return (
                            <Column className={cls(`${DETAILTRANSACTION_COLUMN_BUY_RENT}`)}>
                                <span className={cls(`${DETAILTRANSACTION_SUBTITLE}`)} >{contentTitle}</span><br />
                                <span className={cls(`${DETAILTRANSACTION_SUBTITLE_TOTAL}`)} >{lblTotal}</span>
                                <span {...metadataInfoPrice} className={cls(`${DETAILTRANSACTION_SUBTITLE_PRICE}`)} >{checkoutPrice.label}</span>
                                <span {...metadataInfoTax} className={cls(`${DETAILTRANSACTION_SUBTITLE_DURATION}`)}>{checkoutTax.label}</span>

                            </Column>
                        );
            case TransactionDetailType.RENT_MOVIE:
                return (
                    <Column className={cls(`${DETAILTRANSACTION_COLUMN_BUY_RENT}`)}>
                        <span className={cls(`${DETAILTRANSACTION_SUBTITLE}`)} >{contentTitle}</span><br />
                        <span className={cls(`${DETAILTRANSACTION_SUBTITLE_TOTAL}`)} >{lblTotal}</span>
                        <span {...metadataInfoPrice} className={cls(`${DETAILTRANSACTION_SUBTITLE_PRICE}`)} >{checkoutPrice.label}</span>
                        <span {...metadataInfoTax} className={cls(`${DETAILTRANSACTION_SUBTITLE_DURATION}`)}>{checkoutTax.label}</span>
                    </Column>
                );
            case TransactionDetailType.BUY_SEASON:
                return (
                    <Column className={cls(`${DETAILTRANSACTION_COLUMN_BUY_RENT}`)}>
                        <span className={cls(`${DETAILTRANSACTION_SUBTITLE}`)} >{titleSerie}</span><br />
                        <span className={cls(`${DETAILTRANSACTION_SUBTITLE}`)} >({contentTitle})</span><br />
                        <span className={cls(`${DETAILTRANSACTION_SUBTITLE_TOTAL}`)} >{lblTotal}</span>
                        <span {...metadataInfoPrice} className={cls(`${DETAILTRANSACTION_SUBTITLE_PRICE}`)} >{checkoutPrice.label}</span>
                        <span {...metadataInfoTax} className={cls(`${DETAILTRANSACTION_SUBTITLE_DURATION}`)}>{checkoutTax.label}</span>

                    </Column>
                );
            case TransactionDetailType.SUSCRIPTION:
                return (
                    <Column className={cls(`${DETAILTRANSACTION_COLUMN_SUSCRIPTION}`)}>
                        <img src={providerImage} alt="offer" />
                        <br />
                        {checkoutPrice.label && <span className={cls(`${DETAILTRANSACTION_SUBTITLE_TOTAL}`)} >{lblTotal}</span>}
                        {checkoutPrice.label && <span {...metadataInfoPrice} className={cls(`${DETAILTRANSACTION_SUBTITLE_PRICE}`)} >{checkoutPrice.label}</span>}
                        {checkoutPrice.label && <span {...metadataInfoTax} className={cls(`${DETAILTRANSACTION_SUBTITLE_DURATION}`)}>{checkoutTax.label}</span>}
                        <br />
                        <span {...metadataInfoBonus} className={cls(`${DETAILTRANSACTION_SUBTITLE_CARGO}`)} >{checkoutBonus.label}</span>
                        <br />
                        <span className={cls(`${DETAILTRANSACTION_SUBTITLE_INFORMATION}`)} >{information}</span>
                    </Column>
                );
            default:
                return null as any;
        }
    };



interface ITransactionDetailContentNotesProps {
    contentNotes: string,
    transactionType: TransactionDetailType,
    extraDisclaimer?: string,
}

const TransactionDetailContentNotes: React.StatelessComponent<ITransactionDetailContentNotesProps> =
    ({ contentNotes, transactionType, extraDisclaimer }): JSX.Element => {
        switch (transactionType) {
            case TransactionDetailType.BUY_EPISODE:
            case TransactionDetailType.BUY_SEASON:
                let extraDisclaimerStr = extraDisclaimer ?? '';
                const regExp = /\<bold\>(.*?)\<\/bold\>/;
                let disclaimerArray = extraDisclaimerStr.match(regExp);
                extraDisclaimerStr = extraDisclaimerStr.replace(regExp, '');
                const [, boldDisclaimer = ''] = Array.isArray(disclaimerArray) ? disclaimerArray : [];
                return (
                    <Column>
                    <Row>
                        <span className={cls(`${DETAILTRANSACTION_COLUMN_EXTRA_DISCLAIMER}`)} >
                            {extraDisclaimerStr}<strong>{boldDisclaimer}</strong>
                        </span>
                    </Row>
                    <Row>
                        <span className={cls(`${DETAILTRANSACTION_COLUMN_DISCLAIMER}`)} >
                            {contentNotes}
                        </span>
                    </Row>
                    </Column>
                );
            default:
                return (
                    <Column className={DETAILTRANSACTION_COINTAINER_NOTES}>
                        <span className={cls(`${DETAILTRANSACTION_COLUMN_NOTES}`)} >
                            {contentNotes}
                        </span>
                    </Column>
                );
        }
    };



// WEBPACK FOOTER //
// ./src/packages/components/lib/TransactionDetail/index.tsx